// Horizontal Accordion initialization
function Horizontal_Accordions_ini() {
	let Horizontal_Accordions = [];
	const Accordion_Panels = document.querySelectorAll(
		`.` + block_id_Acc + `_accordion_pane`
	);
	const Accordion_Buttons = document.querySelectorAll(
		`.` + block_id_Acc + `_accordion_list_item`
	);
	let activeAccordionItemIndex = 0;
	let activePaneIndex = 0;

	// Add Event Listener to Accordion Buttons
	Accordion_Buttons.forEach((a_item, index) => {
		Horizontal_Accordions[index] = document.querySelector(
			`#accordion_${block_id_Acc}` + index
		);
		a_item.addEventListener('click', () => {
			removeHiddenClassFromAccordion(index);
			activeAccordionItemIndex = index;
			removeActiveClass();
			let pane = document.querySelector(
				`#accordion_${block_id_Acc}` + index
			);
			addActiveClass(
				pane.querySelector(`.` + block_id_Acc + `_accordion_pane`)
			); // Add active class to the selected pane
		});
	});

	// Add Event Listener to Accordion Panes
	Accordion_Panels.forEach((pane, index) => {
		pane.addEventListener('click', () => {
			removeActiveClass();

			activePaneIndex = index;
			Accordion_Panels[activePaneIndex].classList.add('active');
			Accordion_Panels[activePaneIndex].classList.remove(
				'cursor-pointer'
			);
		});
	});

	// Remove hidden class from the selected Accordion and add hidden class to the rest
	function removeHiddenClassFromAccordion(index) {
		Horizontal_Accordions[activeAccordionItemIndex].classList.add('hidden');
		Accordion_Buttons[activeAccordionItemIndex].classList.remove('active');
		Horizontal_Accordions[index].classList.remove('hidden');
		Accordion_Buttons[index].classList.add('active');
	}

	// Remove active class from all Accordion_Panels
	function removeActiveClass() {
		Accordion_Panels.forEach((pane) => {
			pane.classList.remove('active');
			pane.classList.add('cursor-pointer');
		});
	}

	// Add active class to the selected pane
	function addActiveClass(pane) {
		pane.classList.add('active');
		pane.classList.remove('cursor-pointer');
	}

	// Reset Accordions on page load
	const ResetAccordions = () => {
		removeActiveClass();
		Accordion_Buttons.forEach((_button, index) =>
			_button.classList.remove('active')
		); // Remove active class from all buttons
		Horizontal_Accordions.forEach((accordion, index) =>
			accordion.classList.add('hidden')
		); // Add hidden class to all panes
		Accordion_Panels[0].classList.add('active'); // Add active class to the first pane
		removeHiddenClassFromAccordion(0);
	};
	ResetAccordions();
}
Horizontal_Accordions_ini(); // Initialize Horizontal Accordions
